<section *ngIf="!displayShortNavigation">
  <div class="menuItem sidebar" (click)="redirectTo('tabProjectstd')"
       [ngClass]="{'active': selectedTab === activeTab.Projects}">
    <div class="sidebar-icon-container">
      <svg-icon src='./assets/icons/Project_icon.svg' class="menu-navigation-icon"
                title="{{'projectMain.projects' | translate | uppercase}}" align='center'></svg-icon>
    </div>
    <div class="menu-navigation-title">{{'projectMain.projects' | translate | uppercase}}</div>
  </div>
  <div class="menuItem sidebar" (click)="redirectTo('tabValuationPortfolio')"
       [ngClass]="{'active': selectedTab === activeTab.ValPortofolios}">
    <div class="sidebar-icon-container">
      <svg-icon src='./assets/icons/Val_Portfolios_icon.svg' class="menu-navigation-icon"
                title="{{'projectMain.valuationPortfolios' | translate | uppercase}}" align='center'></svg-icon>
    </div>
    <div class="menu-navigation-title">{{'projectMain.valuationPortfolios' | translate | uppercase}}</div>
  </div>
  <div class="menuItem sidebar" (click)="!remInactive && redirectTo('tabREM')"
       [ngClass]="{'active': selectedTab === activeTab.RiskEChecklist, 'disabled': remInactive}">
    <div class="sidebar-icon-container">
      <svg-icon src='./assets/icons/Properties_icon.svg' class="menu-navigation-icon"
                title="{{'projectMain.rem' | translate | uppercase}}" align='center'></svg-icon>
    </div>
    <div class="menu-navigation-title">{{'projectMain.rem' | translate | uppercase}}</div>
  </div>
  <div class="menuItem sidebar" (click)="!remBcInactive && redirectTo('tabREMBC')"
       [ngClass]="{'active': selectedTab === activeTab.EmaeBusinessCase, 'disabled': remBcInactive}">
    <div class="sidebar-icon-container">
      <svg-icon src='./assets/icons/Tenant_icon.svg' class="menu-navigation-icon"
                title="{{'projectMain.rembc' | translate | uppercase}}" align='center'></svg-icon>
    </div>
    <div class="menu-navigation-title">{{'projectMain.rembc' | translate | uppercase}}</div>
  </div>
</section>
